// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2p3bZ","rightAdornment":"Header_rightAdornment__2vtNO"};